<template>
    <div class="look-for-more-details-container">
        <div class="look-for-more-details-container__title">
            Look for more detailed information on our community pages
        </div>
        <div class="look-for-more-details-container__official-wiki">
            <default-button
                :color="'veryDarkBlue'"
                :style="'width: 230px'"
                :outside="true"
                :text="'OFFICIAL WIKI'"
                :link="'https://ylands.gamepedia.com/Ylands_Wiki'"
            />
        </div>
        <div class="look-for-more-details-container__community-forum">
            <default-button
                :color="'veryDarkBlue'"
                :style="'width: 230px'"
                :text="' COMMUNITY FORUM'"
                :outside="true"
                :link="'https://ylands.com/community/'"
            />
        </div>
        <div class="look-for-more-details-container__youtube-videos">
            <default-button
                :color="'veryDarkBlue'"
                :style="'width: 230px'"
                :text="'YOUTUBE VIDEOS'"
                :outside="true"
                :link="'https://www.youtube.com/c/YlandsGame/featured'"
            />
        </div>
    </div>
</template>

<script>
import Button from '@/components/common/Button';

export default {
    name: 'LookForMoreDetails',
    components: {
        'default-button': Button,
    },
};
</script>

<style scoped lang="scss">
.look-for-more-details-container {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    background: rgba(255, 163, 6, 0.49);
    @media (max-width: $sm-up) {
        grid-template-rows: repeat(5, 6rem);
    }
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
        grid-template-rows: 10rem repeat(4, 6rem);
    }
    &__title {
        height: 40px;
        grid-column: 1 / 6;
        justify-self: center;
        margin: 4rem auto -3rem auto;
        color: #0a294a;
        font-family: $politica-font;
        font-size: 26px;
        font-weight: 700;
        letter-spacing: 0.52px;
        line-height: 40px;
        @media (max-width: $sm-up) {
            width: 486px;
            text-align: center;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            width: 290px;
            margin: 4rem auto auto auto;
        }
    }
    &__official-wiki {
        grid-column: 2;
        justify-self: center;
        @media (max-width: $xl-up) {
            margin: 1rem;
        }
        @media (max-width: $sm-up) {
            grid-column: 2 / 5;
            grid-row: 3;
        }
    }
    &__community-forum {
        grid-column: 3;
        justify-self: center;
        @media (max-width: $xl-up) {
            margin: 1rem;
        }
        @media (max-width: $sm-up) {
            grid-column: 2 / 5;
            grid-row: 4;
        }
    }
    &__youtube-videos {
        grid-column: 4;
        justify-self: center;
        @media (max-width: $xl-up) {
            margin: 1rem;
        }
        @media (max-width: $sm-up) {
            grid-column: 2 / 5;
            grid-row: 5;
        }
    }
    &__manage-text {
        text-transform: uppercase;
    }
}
a:visited {
    color: white;
}
a:link {
    color: white;
}
</style>
